import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}files`;

export interface CreateFileQuoteCommandPayload {
  fileId: string;
  sellerId: string;
}

export const createFileQuoteRequest = (
  payload: CreateFileQuoteCommandPayload,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.fileId}/quotes`,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { sellerId: payload.sellerId },
  },
});

export const createFileQuoteCommand = async (
  payload: CreateFileQuoteCommandPayload,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      createFileQuoteRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
